import { ApolloError } from '@apollo/client';

import { Feature, useIsUserPermittedTo } from '@occc/utils-access-control';
import { ScanDataSftpCredentialsOverviewFragment } from '@occc/graphql';

import { ScanDataSubmissionGroups } from './scan-data-submission-groups.component';
import { useScanDataSubmissionGroups } from './hooks/use-scan-data-submission-groups.hook';

type ScanDataSubmissionGroupsControllerProps = {
  overviewData?: ScanDataSftpCredentialsOverviewFragment;
  overviewLoading: boolean;
  overviewError?: ApolloError;
};

export const ScanDataSubmissionGroupsController = ({
  overviewData,
  overviewLoading,
  overviewError,
}: ScanDataSubmissionGroupsControllerProps) => {
  const isUserPermittedToViewSubmissionGroup = useIsUserPermittedTo(
    Feature.SCAN_DATA_SUBMISSION_GROUPS_VIEW,
  );

  const {
    altriaLoadedDataWithPagination,
    msaLoadedDataWithPagination,
    rjrLoadedDataWithPagination,
  } = useScanDataSubmissionGroups();

  return (
    <ScanDataSubmissionGroups
      showActions={isUserPermittedToViewSubmissionGroup}
      overviewData={overviewData}
      overviewLoading={overviewLoading}
      overviewError={overviewError}
      altriaLoadedDataWithPagination={altriaLoadedDataWithPagination}
      msaLoadedDataWithPagination={msaLoadedDataWithPagination}
      rjrLoadedDataWithPagination={rjrLoadedDataWithPagination}
    />
  );
};
